import React, { Component } from 'react'
import { PageContainerLayout, PageHeaderLayout } from '../../../layouts'
import { NavLink } from 'react-router-dom'
import * as ROUTING_PATHS from '../../../../routing/Paths'
import { AlarmWizardForm } from '../../containers'
import { Session } from '../../../../state/utils/session'

class AlarmCreatorPage extends Component {
  constructor (props) {
    super(props)

    this.state = {
      session: new Session()
    }

    this.renderHeaderPaths = this.renderHeaderPaths.bind(this)
  }

  renderHeaderPaths () {
    return (
            <>
                <li>
                    <NavLink className="link-effect"
                             to={ROUTING_PATHS.CLIENT_DASHBOARD_ALARMS_PATH.replace(':client_id', this.state.session.getClientSession())}>
                        Alarms
                    </NavLink>
                </li>
                <li>New Alarm</li>
            </>
    )
  }

  render () {
    return (
            <>

                <PageContainerLayout clientSidebar={true} showNavbarClientOptions={true}>
                    <PageHeaderLayout
                        title={'New Alarm'}
                        subTitle={'Create a new alarm'}
                        paths={this.renderHeaderPaths}
                    />
                    <AlarmWizardForm/>
                </PageContainerLayout>
            </>
    )
  }
}

export { AlarmCreatorPage }
